import { NodeModel } from "../_model/NodeModel";
import { DecorationFlotador } from "./decorationFlotador";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Flotador extends NodeModel {
  constructor() {
    super("Flotador");

    this.type = new Types().Flotador;
    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 100;
    this.width = 120;
    this.operationSelected = "";
    this.srcImg = require("@/assets/Fluxogramas/flotador.png");
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationFlotador();
      await this.decorator.init(this, callback);
    };

    /* Métodos para serem implementados */

    this.clone = () => {
      let cloned = new Flotador();
      //cloned = { ...this, decorator: null }
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }
    };

    // Para caso o nó tenha connections.
    // this.removeConnection = (connectionId) => {
    //   this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
    // }
  }
}

export { Flotador };
